import { connect } from 'react-redux';
import Pipeline from '../../components/dashboard/pipeline.js';


const FinalPipeline = connect()(Pipeline);


export default FinalPipeline;


// WEBPACK FOOTER //
// ./src/containers/pipeline/pipelineContainer.js